import { ListItemIcon, MenuItem, SelectChangeEvent } from '@mui/material';
import SweepSelect from '../../common/SweepSelect';
import { MicrosoftTeams, SlackLogo } from '@sweep-io/sweep-design/dist/icons';

export const enum DealroomType {
  SLACK = 'slack',
  TEAMS = 'teams',
}

interface DealroomTypeSelectorProps {
  readonly?: boolean;
  type?: DealroomType;
  onChange: (type: DealroomType) => any;
}
export const DealroomTypeSelector = ({ type, onChange }: DealroomTypeSelectorProps) => {
  return (
    <SweepSelect
      FormControlProps={{
        sx: { width: 'fit-content' },
      }}
      SelectProps={{
        placeholder: 'Choose integration',
        value: type,
        renderValue: (val: any) => {
          return val === DealroomType.SLACK ? 'Slack integration' : 'Teams integration';
        },
        onChange: (event: SelectChangeEvent<unknown>) => {
          const val = event.target.value as string;
          val && onChange(val as DealroomType);
        },
      }}
    >
      <MenuItem key={DealroomType.SLACK} value={DealroomType.SLACK}>
        <ListItemIcon>
          <SlackLogo />
        </ListItemIcon>
        Slack integration
      </MenuItem>
      <MenuItem key={DealroomType.TEAMS} value={DealroomType.TEAMS}>
        <ListItemIcon>
          <MicrosoftTeams />
        </ListItemIcon>
        Teams integration
      </MenuItem>
    </SweepSelect>
  );
};
